import { Component, OnInit, Input } from '@angular/core';
import { FormField } from '../../../common/models/form-details.model';
import { WS10ButtonLink, LinkTarget, ButtonLinkColorVariant } from '@vfde-fe/ngx-lib/brix/ws10-button-link';
import { COLOR_VARIANT, DOWNLOAD_ICON, TARGET } from 'src/app/common/constants/Defines';

/** ButtonLinkComponent */
@Component({
  selector: 'app-button-link',
  templateUrl: './button-link.component.html',
})
export class ButtonLinkComponent implements OnInit {
  /** formField */
  @Input() public formField: FormField;

  /** buttonLinkConfig */
  public buttonLinkConfig: WS10ButtonLink;

  /** constructor */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public constructor () {}

  /** ngOnInit */
  public ngOnInit (): void {
    if (this.formField) {
      this.configureComponent(this.formField);
    }
  }

  /** configureComponent
   * @method configureComponent
   * @param {FormField} data
   */
  public configureComponent (data: FormField) {
    if (data.value && data.link) {
      this.buttonLinkConfig = {
        href: data.link,
        target: TARGET.BLANK as LinkTarget,
        label: data.value,
        leftIconName: DOWNLOAD_ICON,
        colorVariant: COLOR_VARIANT as ButtonLinkColorVariant,
        isButtonLinkDisabled: false,
      };
    }

  }
}
